var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "29px",
    height: "65px",
    viewBox: "0 0 29 65",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Path") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Brand-/-dashboard",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "more_info",
    transform: "translate(-26.000000, -24.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.9266578,24 C27.1995926,24 24.3825605,29.3480556 27.0039654,33.3419444 L42.2095362,56.5 L27.0039654,79.6580556 C24.3825605,83.6519444 27.1995926,89 31.9266578,89 C33.9042712,89 35.7538377,87.9961111 36.852907,86.3241667 L53.8048955,60.5047222 C55.3983682,58.0780556 55.3983682,54.9183333 53.8048955,52.4916667 L36.852907,26.6722222 C35.7538377,25.0038889 33.9078281,24 31.9266578,24 Z",
    id: "Path",
    transform: "translate(40.500000, 56.500000) scale(-1, 1) translate(-40.500000, -56.500000) "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronLeft);
export default __webpack_public_path__ + "static/media/chevronLeft.570059cd011b50ee65019ae4c9df0660.svg";
export { ForwardRef as ReactComponent };